import React from 'react';
import Box from "@mui/material/Box";
import {Asset} from "../../codegen/graphql";
import {Typography} from "@mui/joy";
import AssetProductImage from "../AssetProductImage";
import _ from "lodash";
import {Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import moment from "moment";

interface Props {
    asset: Asset;
    onAssetSelect?: () => void;
    selected?: boolean;
}

const AssetSearchResult = ({asset, onAssetSelect, selected}: Props) => {

    const {t} = useTranslation();
    const detailInfo = [
        {
            label: 'Serial no.',
            value: asset?.serialNumber
        },{
            label: 'Manufacturer',
            value: asset?.manufacturer?.name
        },{
            label: 'Product code',
            value: asset?.product?.productCode
        },{
            label: 'Date of manufacture',
            value: asset?.dateOfManufacture ? moment(asset?.dateOfManufacture).format("L") : "-"
        }
    ]


    return <Box className={'flex-row'}
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    height: 132,
                    flexShrink: 0,
                    borderStyle: 'solid',
                    borderWidth: selected ? '2px' : '1px',
                    borderColor: selected ? 'primary.main' : '#ccc',
                    backgroundColor: selected ? 'action.hover' : 'transparent',
                    // Padding shrinks by 1px when selected so the extra border thickness
                    // doesn't shift the inner content. Net inner area stays constant.
                    padding: selected ? '12px' : '13px',
                    borderRadius: '4px',
                    gap: '16px',
                    cursor: 'pointer',
                    boxSizing: 'border-box',
                }}
                onClick={onAssetSelect}
    >
        <Box sx={{padding: '8px', height: '100%'}}>
            <AssetProductImage style={{height: '100%', width: 'auto'}}
                               src={_.get(asset, 'product.image.thumbnailLink')}/>
        </Box>
        <Box className={'flex-col'} sx={{flexGrow: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis"}} alignContent="center">
            <Tooltip title={asset?.product?.name} enterDelay={750}>
                <Typography level={'titleLargeBold'}  noWrap>{asset?.product?.name}</Typography>
            </Tooltip>
            <Box display={'flex'} flexDirection={'column'} gap={'4px'} sx={{pl: '2px'}}>
                {detailInfo.map((detail) => {
                    if (detail.value) {
                        return <Box className={'flex-row'} minWidth={'180px'} gap='5px' key={detail.label}>
                            <Typography level={'bodySmallLight'}>{t(detail.label)}:</Typography>
                            <Typography level={'bodySmallBold'}>{detail.value}</Typography>
                        </Box>
                    }
                    return null;
                })}
            </Box>
        </Box>
    </Box>
};

export default AssetSearchResult;
